import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import { Link, useNavigate } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";

import DataTable from "react-data-table-component";
import DeleteConfirmationModal from "../../../components/Modal/DeleteConfirmation";
import { checkUserPermission } from "../../../common/UserPermission";

//--------Material React Table------//
import { MaterialReactTable } from "material-react-table";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

import { Edit as EditIcon, Delete as DeleteIcon } from "@mui/icons-material";
import { MenuItem } from "@mui/material";
import {
  ERROR_EXISTS,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
} from "../../../common/Constant";
import { toastError, toastSuccess } from "../../../common/Toast";

let PERMISSION_ADD = "/manage-locations";
let PERMISSION_EDIT = "/manage-locations/:id";
let PERMISSION_DELETE = "delete-locations";
let PERMISSION_DELETED_LOCATIONS = "/deleted-locations";

const Locations = () => {
  let selectData = [];

  const token = localStorage.getItem("Token");
  const loginUserId = localStorage.getItem("ID");

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [state, setState] = useState("");
  const [searchtext, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [perPageSize, setperPageSize] = useState(10);
  const [sortingId, setSortingId] = useState(6);
  const [sortingDirection, setSortingDirection] = useState("desc");
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedDataDelete, setSelectedDataDelete] = useState("");
  const [selectedDeliveriesCheckboxs, setselectedDeliveriesCheckboxs] =
    useState("");
  const [toggleCleared, setToggleCleared] = useState(false);
  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [filtertext, setFiltertext] = useState("");

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  //popup on delete
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const navigate = useNavigate();

  const ChangeFilterText = (e) => {
    setSearchText(e.target.value);
    setCurrentPage(1);
    handleListData(1, perPageSize, e.target.value, sortingId, sortingDirection);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    handleListData(page, perPageSize, searchtext, sortingId, sortingDirection);
  };

  const handleSort = (e, sortingDirection) => {
    setSortingId(e.id);
    setSortingDirection(sortingDirection);
    handleListData(1, perPageSize, searchtext, e.id, sortingDirection);
  };

  const handleSaveRow = async ({ exitEditingMode, row, values }) => {
    setLoading(true);
    //if using flat data and simple accessorKeys/ids, you can just do a simple assignment here.
    data[row.index] = values;
    // //send/receive api updates here
    setData([...data]);
    axios
      .post(
        `${config.brandBaseUrl}/locations/upsert`,
        {
          id: row.original.ID,
          isactive: 1,
          name: values.Name,
          loginuserid: loginUserId,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(SUCCESS_MESSAGE);
          // handleListData();
          setLoading(false);
          // window.location.reload();
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError(ERROR_EXISTS);

          setLoading(false);
        } else {
          toastError(ERROR_MESSAGE);
          setLoading(false);
        }
      });
    exitEditingMode(); //required to exit editing mode
  };

  // const handleDeletePopup = (pID) => {
  //   console.log(pID);
  //   const deleteRequestParam = {
  //     id: pID || selectedDataDelete,
  //   };
  //   localStorage.setItem(
  //     "DeleteRequestParam",
  //     JSON.stringify(deleteRequestParam)
  //   );
  //   setDeleteModalOpen(true)
  // };\

  const handleDeletePopup = (id, rows, field) => {
    console.log(id, "id");

    // console.log(rows.map((el) => el.original), "rows231")

    let data;

    if (field === "multipleRowInactive") {
      data = rows.map((el) => el.original.Id).join(",");
    } else {
      data = id;
    }

    const deleteRequestParam = {
      id: data,
    };

    localStorage.setItem(
      "DeleteRequestParam",

      JSON.stringify(deleteRequestParam)
    );

    // setShowDateFilterModal(true);

    // setShowAction(false);

    setDeleteModalOpen(true);
  };

  // const contextActions = useMemo(() => {
  //   axios
  //     .get(
  //       `${config.locationBaseUrl}/locations/delete?id=${selectedDeliveriesCheckboxs}`,
  //       {
  //         headers: {
  //           "Content-Type": "application/json;charset=UTF-8",
  //           Authorization: token,
  //         },
  //       }
  //     )
  //     .then((res) => {});

  //   return (
  //     <>
  //       {checkUserPermission(PERMISSION_DELETE) && (
  //         <button
  //           type="button"
  //           className="btn btn-danger btn-sm pull-left "
  //           data-bs-toggle="modal"
  //           data-bs-target="#DeleteConfirmationModal"
  //           onClick={() => handleDeletePopup()}
  //         >
  //           <i className="fa fa-trash fa-sm" /> Delete Selected
  //         </button>
  //       )}
  //       {/* </a> */}
  //     </>
  //   );
  // }, [data, selectedRows, toggleCleared]);

  const handleRowSelected = (e) => {
    if (e.selectedRows.length > 0) {
      setSelectedRows(e.selectedRows.map((x) => x.Id));
      selectData[currentPage] = e.selectedRows.map((x) => x.Id);
      console.log(e.selectedRows.map((x) => x.Id));
      const selectedDeliveriesCheckboxIDs =
        selectData.length > 0 ? selectData[currentPage].toString() : "";
      const selectedDataDelete =
        selectData.length > 0 ? selectData[currentPage].toString() : "";
      setSelectedDataDelete(selectedDataDelete);
      setselectedDeliveriesCheckboxs(selectedDeliveriesCheckboxIDs);
    }
  };
  //   Get all Suppliers data
  const handleListData = (
    pagenumber,
    pagesize,
    filtertext,
    ordercolumn,
    currentorder,
    columnFilters,
    globalFilter,
    pagination,
    sorting
  ) => {
    setLoading(true);

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters;

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    // const columnIndex = columns.findIndex(
    //   (column) => column.accessorKey === sorting[0]?.id
    // );
        const columnIndex = ((sorting.length > 0) ? sorting[0]?.id : "") 

    axios
      .get(
        `${
          config.locationBaseUrl
        }/locations/listoflocations??filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex}&pagenumber=${
          pagination.pageIndex + 1
        }&pagesize=${pagination.pageSize}&filtertext=${
          globalFilter == undefined ? "" : globalFilter
        }`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res);
        setData(res.data.ResponseData);
        setTotalRows(res.data.ResponseData[0]?.TotalRecord);
        setRowCount(res.data.ResponseData[0]?.TotalRecord);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
    setIsError(false);
    setIsLoading(false);
    setIsRefetching(false);
  };

  useEffect(() => {
    handleListData(
      1,
      perPageSize,
      searchtext,
      sortingId,
      sortingDirection,
      columnFilters,
      globalFilter,
      pagination,
      sorting
    );
  }, [searchtext, columnFilters, globalFilter, pagination, sorting]);

  const handlePerRowsChange = async (page, newPerPage) => {
    setperPageSize(newPerPage);
    setCurrentPage(page);
    handleListData(page, newPerPage, searchtext, sortingId, sortingDirection);
  };
  const formatDate = (string) => {
    var options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(string).toLocaleDateString([], options);
  };

  // Table Data
  const columns = useMemo(() => [
    {
      header: "Location ID",
      accessorKey: "Id",
      size: 120,
      Cell: checkUserPermission(PERMISSION_EDIT) 
        ? ({ row }) => (
            <Box
              component="span"
              sx={(theme) => ({
                borderRadius: "0.3rem",
                color: "#343f62",
                maxWidth: "18ch",
                fontWeight:"700",
                textDecoration:"underline",
                textUnderlineOffset: "3px",
                p: "0.3rem",
                cursor: "pointer",
              })}
              onClick={() =>
                navigate(`/manage-locations/${row.original.Id}`)
              }
            >
              {row.original.Id}
            </Box>
          ) 
        : null,
      filterFn: "contains",
    },
    {
      header: "Name",
      accessorKey: "Name",
      // size:"100",
    },
    {
      header: "Address",
      accessorKey: "Address",
    },
    {
      header: "Phone",
      accessorKey: "Phone",
      // size:"100",
    },
    {
      header: "Email",
      accessorKey: "Email",
      // size:"100",
    },
  ]);

  // store checkbox checked values to hide or show columns

  // function handleCheckboxChange(columnName) {
  //   if (String(hiddenColumns).includes(columnName)) {
  //     setHiddenColumns(hiddenColumns.filter((column) => column !== columnName));
  //   } else {
  //     setHiddenColumns([...hiddenColumns, columnName]);
  //   }
  // }

  // generate new columns according to hiddenColumns data and pass it as datatable column
  // const filteredColumns = columns.filter(
  //   (column) => !hiddenColumns.includes(column.name.replace(/\s+|-|\/|#/g, ""))
  // );

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <div className="col"> */}
              {/* <h3 className="page-title">Locations</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">Locations List</li>
              </ul>
              {/* </div> */}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "20px",
            }}
          >
            <div className="col-md-4">
              {/* <input
                type="search"
                placeholder="Search..."
                className="search-btn form-control form-control-sm w-50 "
                onChange={ChangeFilterText}
                value={searchtext}
              /> */}
            </div>
            <div>
              {/* dynamically hide or show columns */}
              {/* <div className="btn-group pull-right ms-2 dropdown">
                <button
                  type="button"
                  className="btn btn-sm btn-outline-primary dropdown-toggle"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  style={{ borderRadius: "5px" }}
                >
                  <i className="fa fa-cog"></i> &nbsp;
                </button>
                <div className="dropdown-menu">
                  {columns.map((column) =>
                    // omit Action column
                    column.name.replace(/\s+|-|\/|#/g, "") !== "Action" ? (
                      <div
                        key={column.name.replace(/\s+|-|\/|#/g, "")}
                        className="form-check ms-2 mt-1"
                      >
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`checkbox-${column.name.replace(
                            /\s+|-|\/|#/g,
                            ""
                          )}`}
                          value={column.name.replace(/\s+|-|\/|#/g, "")}
                          checked={
                            !hiddenColumns.includes(
                              column.name.replace(/\s+|-|\/|#/g, "")
                            )
                          } // check all checkboxes which are not include in hiddenColumns
                          onChange={() =>
                            handleCheckboxChange(
                              column.name.replace(/\s+|-|\/|#/g, "")
                            )
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`checkbox-${column.name.replace(
                            /\s+|-|\/|#/g,
                            ""
                          )}`}
                        >
                          {column.name}
                        </label>
                      </div>
                    ) : (
                      ""
                    )
                  )}
                </div>
              </div> */}
              <div className="btn-group pull-right ms-2">
                <button
                  type="button"
                  className="btn btn-sm btn-outline-dark d-none"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  More
                </button>
                {checkUserPermission(PERMISSION_DELETED_LOCATIONS) && (
                  <>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-dark dropdown-toggle me-1"
                      data-bs-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      style={{ borderRadius: "5px" }}
                    >
                      More &nbsp;
                    </button>
                    <div className="dropdown-menu">
                      <li>
                        <Link class="dropdown-item" to="/deleted-locations">
                          Manage Deleted Locations
                        </Link>
                      </li>
                    </div>
                  </>
                )}
              </div>
              {checkUserPermission(PERMISSION_ADD) && (
                <Link
                  // className="btn btn-added pull-right"
                  className="btn btn-primary btn-sm pull-right"
                  style={{ width: "max-content" }}
                  to={`/manage-locations`}
                >
                  <i className="fa fa-plus me-2 lg"></i>
                  New Locations
                </Link>
              )}
            </div>
          </div>

          {/* <div className="row flex-row-reverse mt-2">
            <div className="col-lg-3 col-md-6 col-sm-12 mb-2">
              <input
                type="search"
                placeholder="Search..."
                className="search-btn form-control form-control-sm w-50 pull-right"
                onChange={ChangeFilterText}
                value={searchtext}
              />
            </div>
          </div> */}

          {/* Customer list */}
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                {/* <DataTable
                  title="Locations List"
                  columns={filteredColumns}
                  data={data}
                  progressPending={loading}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationDefaultPage={currentPage}
                  onChangeRowsPerPage={(e) => {
                    handlePerRowsChange(1, e);
                  }}
                  onChangePage={handlePageChange}
                  highlightOnHover
                  striped
                  responsive
                  paginationRowsPerPageOptions={[10, 25, 50, 100, 500]}
                  // fixedHeader
                  // fixedHeaderScrollHeight="70vh"
                  persistTableHead
                  sortServer
                  onSort={handleSort}
                  selectableRows
                  //   onSelectedRowsChange={e => { handleSelectedRowsChange(e); }}
                  contextActions={contextActions}
                  onSelectedRowsChange={handleRowSelected}
                  clearSelectedRows={toggleCleared}
                /> */}

                <MaterialReactTable
                  columns={columns}
                  //  title="Deleted Customer List"
                  data={data}
                  // positionPagination='top'
                  enableColumnResizing
                  enableGrouping
                  enableStickyHeader
                  enableStickyFooter
                  enableRowSelection
                  enableColumnOrdering
                  enableRowActions={checkUserPermission(PERMISSION_EDIT) || checkUserPermission(PERMISSION_DELETE)}
                  positionGlobalFilter="left"
                  // editDisplayMode="row"
                  // enableEditing
                  // onEditingRowSave={handleSaveRow}
                  renderRowActionMenuItems={({ row, table }) => [
                    checkUserPermission(PERMISSION_EDIT) ? (
                      <MenuItem
                        key="edit"
                        // onClick={() => {
                        //   table.setEditingRow(row);
                        // }}
                        onClick={() =>
                          navigate(`/manage-locations/${row.original.Id}`)
                        }
                      >
                        {/* <EditIcon /> */}
                        Edit
                      </MenuItem>
                    ) : (
                      ""
                    ),
                    checkUserPermission(PERMISSION_DELETE) ? (
                      <MenuItem
                        className="confirm-text"
                        to="#"
                        key="delete"
                        // title="Delete"
                        // data-bs-toggle="modal"
                        // data-bs-target="#DeleteConfirmationModal"
                        // onClick={() => handleDeletePopup(row.original.Id)}
                        // data-bs-toggle="modal"
                        // data-bs-target="#DeleteConfirmationModal"
                        onClick={() =>
                          handleDeletePopup(row.original.Id, "", "")
                        }
                      >
                        {/* <DeleteIcon /> */}
                        Delete
                      </MenuItem>
                    ) : (
                      ""
                    ),
                  ]}
                  renderTopToolbarCustomActions={({ table }) => (
                    <Box
                      sx={{
                        display: "flex",
                        gap: "1rem",
                        p: "0.5rem",
                        flexWrap: "wrap",
                      }}
                    >
                      {console.log(table, "tables")}

                      {checkUserPermission(PERMISSION_DELETE) ? (
                        <Button
                           // size="small"
                 className="btn btn-sm btn-secondary"
                 style={{display:"flex"}}
                          disabled={
                            !table.getIsSomeRowsSelected() &&
                            !table.getIsAllRowsSelected()
                          }
                          onClick={() =>
                            handleDeletePopup(
                              "",
                              table.getSelectedRowModel().rows,
                              "multipleRowInactive"
                            )
                          }
                          startIcon={<DeleteIcon />}
                          variant="contained"
                        >
                          Delete Selected
                        </Button>
                      ) : (
                        ""
                      )}
                      {/* <Button
                        size="small"
                        onClick={() =>
                          // setPagination({ ...pagination, pageSize: totalRows })
                          setPagination({ ...pagination, pageIndex: 0, pageSize: totalRows })
                        }
                        variant="contained"
                      >
                        Get All Data
                      </Button> */}
                    </Box>
                  )}
                  // rowVirtualizerOptions={{
                  //   overscan: 10, //adjust the number or rows that are rendered above and below the visible area of the table
                  //   estimateSize: () => 100, //if your rows are taller than normal, try tweaking this value to make scrollbar size more accurate
                  // }}
                  muiTableBodyProps={{
                    sx: () => ({                    
                      '& tr:nth-of-type(even)': {
                         backgroundColor: 'var(--datatable-row-background-color)'
                         //'rgb(237 237 233 / 63%)'
                      },
                      '& td': {borderRight: '1px solid var(--datatable-row-background-hover-color)',
                    lineHeight: '16px',
                      fontWeight: '400',
                      fontSize:'12px',
                      color:'var(--primary-color-800)',
                      fontFamily:'Inter'},
                     
                      '& tr': {lineHeight: '16px',
                      fontWeight: '400',
                      fontSize:'12px',
                      color:'var(--primary-color-800)',
                      fontFamily:'Inter'}
                    })
                    }}
                  muiTableContainerProps={{
                    sx: { maxHeight: "fit-content" },
                  }}
                  initialState={{
                    density: "compact",
                    showGlobalFilter: true,
                    expanded: true, //expand all groups by default
                    // grouping: [""], //an array of columns to group by by default (can be multiple)
                    pagination: { pageIndex: 0, pageSize: 10 },
                    // sorting: { id: "Name", desc: false }, //sort by state by default
                  }}
                  muiPaginationProps={{
                    rowsPerPageOptions: [10, 25, 50, 100, 300],
                  }}
                  manualPagination
                  manualSorting
                  muiToolbarAlertBannerProps={
                    isError
                      ? {
                          color: "error",
                          children: "Error loading data",
                        }
                      : undefined
                  }
                  // onColumnFiltersChange={setColumnFilters} // for termp comment filteron column
                  muiTableHeadCellProps={{
                    sx: theme => ({
                      background: 'var(--datatable-row-background-color)',//'#e9e9e9',
                      borderRight: '1px solid var(--datatable-row-background-hover-color)',
                      lineHeight: '16px',
                      fontWeight: '500',
                      fontSize:'14px',
                      color:'var(--primary-color-800)',
                      fontFamily:'Inter'
                    })
                  }}

                  onGlobalFilterChange={setGlobalFilter}
                  onPaginationChange={setPagination}
                  onSortingChange={setSorting}
                  rowCount={rowCount}
                  // enableColumnVirtualization={false}

                  // enableColumnVirtualization

                  state={{
                    // columnFilters, // for termp comment filteron column
                    globalFilter,
                    filtertext,
                    isLoading,
                    pagination,
                    showAlertBanner: isError,
                    showProgressBars: isRefetching,
                    sorting,
                  }}
                />

                {/* <Table columns={columns} dataSource={data} /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <DeleteConfirmationModal
        deleteApiUrl={`${config.locationBaseUrl}/locations/delete`}
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
      />
      {/* Cleanup old suppliers */}
      {/* <CleanupConfirmationModal
        CleanupConformationApiUrl={`${config.deliveriesBaseUrl}/deliveries/deletepermanantely`}
      /> */}
    </>
  );
};

export default Locations;
